import React, { MouseEvent } from 'react'
import {
    Button,
    CopyIcon,
    PlusIcon,
    SingleSelect,
    Switch,
    TextField,
    Tooltip,
    TrashIcon,
} from '@diversioteam/diversio-ds'

import { focusElement, FORM_FIELDS } from '../../formBuilder.helpers'

import { FieldWrapperProps } from './fieldWrapper.types'
import * as S from './../fields.styles'

export const FieldWrapper = ({
    item,
    isActive,
    isDeleteElementButtonDisabled,
    onAddElement,
    onChangeElementValue,
    onDeleteElement,
    onToggleRequired,
    onChangeElementType,
    onDuplicateElement,
    onChangeActiveElement,
    children,
}: FieldWrapperProps) => {
    return (
        <S.FieldWrapper onClick={() => onChangeActiveElement(item.id)}>
            {isActive && (
                <Tooltip title="Add Question" aria-label="Add Question">
                    <S.AddQuestionButton
                        iconOnly
                        onClick={(e: MouseEvent<HTMLButtonElement>) => {
                            e.stopPropagation()

                            onAddElement()
                        }}
                        color="primaryWhite"
                    >
                        <PlusIcon type="bold" />
                    </S.AddQuestionButton>
                </Tooltip>
            )}

            <S.FieldContainer>
                <S.QuestionRow>
                    <TextField
                        name={`question-${item.id}`}
                        aria-label="Question"
                        defaultValue={item.value}
                        onBlur={(e) => onChangeElementValue(item.id, e.target.value)}
                        onFocus={focusElement}
                        required={item.required}
                        placeholder="Question"
                        variant="filled"
                        fullWidth
                        multiline
                    />

                    <SingleSelect
                        color="light"
                        variant="block"
                        options={FORM_FIELDS}
                        value={item.type}
                        onChange={(value) => onChangeElementType(item.id, value)}
                    />
                </S.QuestionRow>

                {children}

                <S.Footer>
                    <Tooltip title="Duplicate Question" aria-label="duplicate-question">
                        <Button
                            aria-label="Duplicate Question"
                            onClick={(e) => {
                                e.stopPropagation()

                                onDuplicateElement(item.id)
                            }}
                            color="transparent"
                            iconOnly
                        >
                            <CopyIcon type="line" />
                        </Button>
                    </Tooltip>

                    <Tooltip title="Delete Question" aria-label="Delete Question">
                        <Button
                            disabled={isDeleteElementButtonDisabled}
                            onClick={(e) => {
                                e.stopPropagation()

                                onDeleteElement(item.id)
                            }}
                            color="transparent"
                            iconOnly
                        >
                            <TrashIcon type="line" />
                        </Button>
                    </Tooltip>

                    <S.SwitchWrapper>
                        <Switch
                            checked={item.required}
                            onChange={() => onToggleRequired(item.id)}
                            inputProps={{ role: 'switch', 'aria-labelledby': `required-switch-${item.id}` }}
                        />

                        <S.SwitchLabel id={`required-switch-${item.id}`}>Required</S.SwitchLabel>
                    </S.SwitchWrapper>
                </S.Footer>
            </S.FieldContainer>
        </S.FieldWrapper>
    )
}
